"use client";

import { useEffect } from "react";
import { isStaleClientReason } from "@/lib/stale-client";
import {
  handleStaleClientError,
  installStaleClientHandledErrorHandlers,
} from "@/lib/stale-client-handlers";

export function StaleClientListener() {
  useEffect(() => {
    const uninstall = installStaleClientHandledErrorHandlers();

    const handleError = (event: ErrorEvent) => {
      if (!isStaleClientReason(event.error ?? event.message)) {
        return;
      }

      event.preventDefault();
      handleStaleClientError(event.error ?? event.message);
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (!isStaleClientReason(event.reason)) {
        return;
      }

      event.preventDefault();
      handleStaleClientError(event.reason);
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);

    return () => {
      uninstall();
      window.removeEventListener("error", handleError);
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
    };
  }, []);

  return null;
}
